import './HomeBoard.css'
import HeroSection from '../home/HeroSection'
import WhatIsFlashUSDT from '../home/WhatIsFlashUSDT'
import ProtocolDocs from '../home/ProtocolDocs'
import WhoCanUse from '../home/WhoCanUse'
import Benefits from '../home/Benefits'
import FAQ from '../home/FAQ'


interface HomeBoardProps {
    onNavigateToOrder: () => void
}

export default function HomeBoard({ onNavigateToOrder }: HomeBoardProps) {
    return (
        <div className="home-board">
            <HeroSection onNavigateToOrder={onNavigateToOrder} />
            <WhatIsFlashUSDT />
            <ProtocolDocs />
            <WhoCanUse />
            <Benefits />
            <FAQ />
        </div>
    )
}
